module.exports = __webpack_public_path__ + "static/media/saudiaramco.f65bf878.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/saudiaramco.png
// module id = 59
// module chunks = 0